export default {
    bind(el, binding) {
        let click = () => {
            // let src = binding;

            let element = document.getElementById(binding.value);

            if (element.classList.contains('collapse')) {
                element.classList.remove('collapse')
            } else {
                element.classList.add('collapse')
            }
        };

        el.addEventListener('click', click);
    }
}